import React, { FC, useState, useEffect } from 'react';
import {
  GlobalDesignDefaultAction,
  GlobalDesignPanelProps,
  HostMetadata,
} from './types';
import { Host } from '@wix/sdk';
import { Box } from '@wix/design-system';

export const DefaultActionPanel: FC<
  GlobalDesignPanelProps & {
    action: GlobalDesignDefaultAction;
  }
> = ({ action, editorPointers, getHost, actionName, componentsAPI }) => {
  const [hosts, setHosts] = useState<{ host: Host; metadata: HostMetadata }[]>(
    [],
  );

  useEffect(() => {
    (async () => {
      setHosts(
        await action.getHosts(
          actionName,
          editorPointers,
          getHost,
          componentsAPI,
        ),
      );
    })();
  }, [action, editorPointers, getHost, actionName, componentsAPI]);

  if (hosts.length === 0 || !action) {
    return null;
  }

  return (
    <Box direction="vertical">
      {React.createElement(action.panel, { hosts })}
    </Box>
  );
};
